<asw-roundtrip-flight-availability-international-pres
  [props]="this.props"
  (clickShowOtherFlightsEvent)="this.clickShowOtherFlightsButton($event)"
>
</asw-roundtrip-flight-availability-international-pres>
